// 开启 HMR 支持
import 'react-hot-loader';
import React from 'react';
import ReactDOM from 'react-dom';
import App from '@/App.tsx';

ReactDOM.render(<App />, document.getElementById('root'));
